import { axiosInstance } from '@/services/core/base';
import Core from '@/services/core';

class Transactions extends Core {
  constructor(axios = axiosInstance) {
    super(axios);
  }

  fetchAll(params = '') {
    return this.get('wallet-transaction' + (params ? '?' + params : ''));
  }
  fetchClients(params = '') {
    return this.get('client' + (params ? '?' + params : ''));
  }

  fetchClient(id) {
    return this.get('client/' + id);
  }

  updateClient(id, payload) {
    return this.put('client/' + id, payload);
  }

  updateClientBalance(id, amount) {
    return this.updateClient(id, { balance: amount });
  }
}

export default Transactions;
